import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import BarrasSimples from "./barrasSimple";
export const PactometroBarras = ({
  data,
  totalSeat,
  selecteds,
  type = "GENERAL"
}) => {
  const selectedData = data.filter(item => selecteds.some(select => select === item.id));

  const _selectedData$reduce = selectedData.reduce((ac, current) => {
    return {
      seat: ac.seat + current.seats,
      percent: ac.percent + (current.votesPercent || 0)
    };
  }, {
    seat: 0,
    percent: 0
  }),
        seat = _selectedData$reduce.seat,
        percent = _selectedData$reduce.percent;

  return React.createElement(Fragment, null, React.createElement(BarrasSimples, {
    data: selectedData,
    selecteds: selecteds,
    totalSeat: totalSeat,
    centerProps: {
      position: "down",
      lineStyle: "solid"
    }
  }), React.createElement(BarrasSimples, {
    data: selectedData,
    selecteds: selecteds,
    totalSeat: totalSeat,
    centerProps: {
      position: "down",
      lineStyle: "solid",
      text: "50%"
    },
    title: React.createElement("span", null, "Total votos:", " ", React.createElement("span", {
      className: "total-pactometro-value"
    }, percent.toFixed(2), "%"))
  }));
};
PactometroBarras.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })).isRequired,
  selecteds: PropTypes.arrayOf(PropTypes.string).isRequired,
  totalSeat: PropTypes.number.isRequired
};
export default PactometroBarras;